import { styled, css } from 'styled-components';
import { motion } from "framer-motion";

export const TableContainerStyled = styled(motion.div)`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    overflow-x: none;
    overflow-y: auto; /* Cambiado de scroll a auto */
    position: relative;
    box-sizing: border-box;


    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.4);
    }

    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
`;

export const TableItemStyled = styled(motion.div)<{ isFirstItem?: boolean; isCurrentUser: boolean }>`
    flex: 1;
    display: flex;
    height: 52px;
    padding: 8px;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    border-radius: var(--Sizes-borderRadiusItem, 12px);
    
    ${({ isFirstItem, isCurrentUser }) => css`
        background: var(--Text-Colors-muted, rgba(255, 255, 255, 0.05));

        ${isFirstItem &&
        `background: linear-gradient(0deg, var(--Theme-Colors-contentBg, rgba(26, 26, 26, 0.50)) 0%, 
        var(--Theme-Colors-contentBg, rgba(26, 26, 26, 0.50)) 100%), var(--Common-Colors-yellow, #FFC72C);`}

        ${isCurrentUser && !isFirstItem && 'background: linear-gradient(0deg, var(--Theme-Colors-contentBg, rgba(26, 26, 26, 0.50)) 0%, var(--Theme-Colors-contentBg, rgba(26, 26, 26, 0.50)) 100%), var(--Theme-Colors-brandColor3, #00A1FA);'}
    `}

    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);
    backdrop-filter: blur(8px);
    position: ${({ isCurrentUser }) => (isCurrentUser ? 'sticky' : 'relative')};
    top: 0;
    z-index: ${({ isCurrentUser }) => (isCurrentUser ? '5' : '0')};
    color: ${({ isCurrentUser }) => isCurrentUser ? 'rgba(255, 255, 255, 0.90)':'rgba(255, 255, 255, 0.50)'}; 
`;

export const TextContainerStyled = styled.div`
    width: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex: 1 0 0;

    p {
        color: var(--Text-Colors-headings, rgba(255, 255, 255, 0.90));
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
        overflow: hidden;
        text-overflow: ellipsis; 
        display: -webkit-box; 
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;

    }
`;

export const IconContainerStyled = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    height: 12px;
    align-self: stretch;
    color: var(--Text-Colors-neutral, rgba(255, 255, 255, 0.50));
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 12px */
`;

export const TextNumberPositionStyled = styled.span<{ $isCurrentUser: boolean }>`
    color: ${({ $isCurrentUser}) => $isCurrentUser ? 'rgba(255, 255, 255, 0.90)':'rgba(255, 255, 255, 0.50)'};
    text-align: right;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 24px */
`;


export const ButtonCollapseContainerStyled = styled.button`
    margin: 0 auto;
    border: none;
    box-shadow: none;
    padding: 0px;
    background: transparent;
    color: white;
    cursor: pointer;
`;